import React, { lazy } from 'react';
import ErrorBoundary from '../components/ErrorBoundary';

// A failed deferred download should not unmount the rest of the dashboard.
// Suspense still owns loading; only module failures get this local boundary.
export default function lazyWithModuleBoundary(load) {
    const LazyComponent = lazy(load);
    return function DeferredModule(props) {
        return (
            <ErrorBoundary moduleOnly>
                <LazyComponent {...props} />
            </ErrorBoundary>
        );
    };
}
